import type { Option } from '@openx/types/options.ts';
import uniqBy from 'lodash/uniqBy';
import type { TaxonomyMetadata } from './types.ts';

export type FilterOptions = {
  categories: Option[];
  sources: Option[];
  subCategories: Option[];
  types: Option[];
};

export const mapTaxonomyFilters = (metadata: TaxonomyMetadata[]) => {
  const filters = metadata.reduce(
    (acc, { segment_category, segment_source, segment_sub_category, segment_type }) => {
      segment_category && acc.categories.push({ id: segment_category, name: segment_category });
      segment_source && acc.sources.push({ id: segment_source, name: segment_source });
      segment_sub_category && acc.subCategories.push({ id: segment_sub_category, name: segment_sub_category });
      segment_type && acc.types.push({ id: segment_type, name: segment_type });

      return acc;
    },
    { categories: [], sources: [], subCategories: [], types: [] } as FilterOptions
  );

  filters.categories = uniqBy(filters.categories, 'id');
  filters.sources = uniqBy(filters.sources, 'id');
  filters.subCategories = uniqBy(filters.subCategories, 'id');
  filters.types = uniqBy(filters.types, 'id');

  return filters;
};
